module.exports = __webpack_public_path__ + "static/media/blueswatch1.b871c1d0.png";